export default {
  title: {
    line1: "хотите сотрудничать с vision?".toUpperCase(),
    line2: "хотите разместить свой проект на vision?".toUpperCase(),
    line3: "есть жалобы на то, как мы оценили ваш проект?".toUpperCase(),
  },
  sub_title: "По любым вопросам — просто напишите нам. мы адекватные и всегда готовы к диалогу!".toUpperCase(),
  link: {
    telegram: "VISION SUPPORT в TELEGRAM".toUpperCase(),
    signal: "VISION SUPPORT в signal".toUpperCase(),
    watsapp: "VISION SUPPORT в watsapp".toUpperCase(),
  },
}
